<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import Loading from '@/components/atoms/Loading/index.vue'
import QuestionsTemplate from '@/components/templates/common/questions/QuestionsTemplate/index.vue'
import QuestionsFourContent from '@/components/organisms/common/questions/QuestionsFourContent/index.vue'
import { useVueInject } from '@/hooks/vue'
import { QuestionsStoreKey, QuestionsStore } from '@/stores/common/questions'
import { useStates, useActions } from '.'

const router = useRouter()
const store = useVueInject<QuestionsStore>(QuestionsStoreKey)
const states = useStates(store)
const actions = useActions(store, router)

onMounted(async () => {
  if (states.isLoading) {
    await store.getCategories()
    states.isLoading = false
  }
})
</script>

<template>
  <QuestionsTemplate
    :page-number="4"
    :question-text="'撮影予定のジャンルを選択してください。'"
    :input-value="store.state.inputs.category"
  >
    <Loading :is-loading="states.isLoading" />
    <div>
      <QuestionsFourContent
        :categories="store.state.categories"
        :selected="store.state.inputs.category"
        @input="actions.handleInput"
      />
    </div>
  </QuestionsTemplate>
</template>
